import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// Modules
import AuthStore from '../../Authentication/store/auth_state';
import BreadCrumbs from './modules/BreadCrumb/bread_crumb_state';
import GlobalError from './modules/GlobalError/error_state';
import SettingsModule from '../../Pretailer/Modules/Settings/store/settings';
import InventoryModule from '../../Pretailer/Modules/Inventory/store';
import OutletModule from '../../Pretailer/Modules/Outlet/store/state';
import CustomerModule from '../../Pretailer/Modules/Customer/store/state';
import OrderModule from '../../Pretailer/Modules/Order/store/state';
import PaymentModule from '../../Pretailer/Modules/Payment/store/state';
import Dashboard from '../../Dashboard/store/dashboard_state';
import SecurityModule from '../../Pretailer/Modules/Security/store/security';
import LoyaltyModule from '../../Pretailer/Modules/Loyalty/store/state';
import CouponModule from '../../Pretailer/Modules/Coupons/store/state';
import Global from './modules/Global/global';

// AI Modules
import MerchantFiles from '../../Analytics/Modules/MerchantFiles/store/state';
import AICustomers from '../../Analytics/Modules/Customer360/store/state';
import AIGeospatial from '../../Analytics/Modules/GeospatialAnalysis/store/state';
import Recommendation from '../../Analytics/Modules/Recommendations/store/state';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    AuthStore,
    BreadCrumbs,
    GlobalError,
    SettingsModule,
    InventoryModule,
    OutletModule,
    CustomerModule,
    OrderModule,
    PaymentModule,
    Dashboard,
    SecurityModule,
    MerchantFiles,
    AICustomers,
    AIGeospatial,
    Global,
    Recommendation,
    LoyaltyModule,
    CouponModule
  },
  plugins: [createPersistedState({
    key: process.env.VUE_APP_LS_KEY,
    paths: [
      'AuthStore.user',
      'AuthStore.token',
      'AuthStore.merchant',
      'SettingsModule.Location',
      'InventoryModule.Catalog.baseData',
      'InventoryModule.Catalog.categories',
      'InventoryModule.Catalog.microCategories',
      'InventoryModule.Catalog.subCategories',
      'InventoryModule.Catalog.currentSelected',
      'InventoryModule.Products.create',
      'InventoryModule.Products.products',
      'InventoryModule.Products.pagination',
      'SettingsModule',
    ],
  })],
});

export default store;
